function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h24v24H0z"
}), React.createElement("path", {
  fill: "#888",
  d: "M9.579 4c-.494 0-1.174.279-1.526.632l-3.421 3.42C4.282 8.403 4 9.08 4 9.58v4.842c0 .494.279 1.174.632 1.526l3.42 3.421c.35.35 1.027.632 1.527.632h4.842c.494 0 1.174-.279 1.526-.632l3.421-3.42c.35-.35.632-1.027.632-1.527V9.58c0-.494-.279-1.174-.632-1.526l-3.42-3.421C15.597 4.282 14.92 4 14.42 4H9.58z"
}), React.createElement("rect", {
  width: 1,
  height: 5.071,
  x: 11.507,
  y: 8,
  fill: "#FFF",
  rx: 0.5
}), React.createElement("circle", {
  cx: 11.969,
  cy: 14.761,
  r: 1,
  fill: "#FFF"
}));

var SvgNoMailContent = function SvgNoMailContent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoMailContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-mail-content.c318fac4.svg";
export { ForwardRef as ReactComponent };